import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import ListItem from './ListItem';
import { useT } from "contexts/TranslationContext";

// Define color constants
const PRIMARY_GREEN = '#4CAF50';
const LIGHT_GREEN_BORDER = '#E8F5E9';

// --- Target Audience Section Component ---
const TargetAudienceSection = () => {
    const t = useT();
    const audiences = [
        {
            title: t("audience.freelancers"),
            description: t("audience.freelancersDesc"),
        },
        {
            title: t("audience.businesses"),
            description: t("audience.businessesDesc"),
        },
        {
            title: t("audience.projectManagers"),
            description: t("audience.projectManagersDesc"),
        },
        {
            title: t("audience.teams"),
            description: t("audience.teamsDesc"),
        },
    ];

    // Split the audience data into two columns for the layout
    const column1 = audiences.filter((_, index) => index % 2 === 0);
    const column2 = audiences.filter((_, index) => index % 2 !== 0);

    return (
        <Box
            component="section"
            sx={{
                bgcolor: LIGHT_GREEN_BORDER,
                pt: { xs: 8, md: 12 },
                pb: { xs: 10, md: 16 },
                px: { xs: 4, sm: 8, lg: 16 },
                width: '100%',
                maxWidth: 'lg',
                mx: 'auto',
                borderRadius: { xs: 0, sm: '12px' },
            }}
        >
            {/* Main Title */}
            <Typography
                variant="h4"
                component="h2"
                textAlign="center"
                sx={{
                    fontWeight: 800,
                    color: 'grey.900',
                    mb: 3,
                    fontSize: { xs: '2rem', sm: '2.5rem' }
                }}
            >
                {t("audience.title")}
            </Typography>

            {/* Subtitle/Intro Text */}
            <Typography
                variant="body1"
                textAlign="center"
                sx={{
                    color: 'grey.700',
                    maxWidth: 700,
                    mx: 'auto',
                    mb: { xs: 8, md: 10 }
                }}
            >
                {t("audience.subtitle")}
            </Typography>

            {/* Two-Column Audience Grid */}
            <Grid container spacing={{ xs: 4, md: 8 }} justifyContent="center">
                <Grid item xs={12} md={5}>
                    {column1.map((item, index) => (
                        <ListItem 
                            key={index} 
                            title={item.title} 
                            description={item.description} 
                        />
                    ))}
                </Grid>
                <Grid item xs={12} md={5}>
                    {column2.map((item, index) => (
                        <ListItem 
                            key={index} 
                            title={item.title} 
                            description={item.description} 
                        />
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default TargetAudienceSection;
